/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:7de69612-9095-41f1-93cc-e75c8c5ec775",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_LPDUwFvxv",
    "aws_user_pools_web_client_id": "279nqt30p03i8fnsoegrdgc2ma",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "virtualofficeapi",
            "endpoint": "https://hxdiql4u32.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamodbuser-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "dynamodbroom-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "dynamodbassign-prod",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "dynamodbnotification-prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "virtualofficestorage155851-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_appsync_apiKey": "da2-fakeApiId123456"
};


export default awsmobile;
